/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {AnimaFadeinTop} from '../../../../_metronic/assets/animation/styles'
// import {PropertiesMap} from './pages/mapa/PropertiesMap'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Toolbar2} from '../../../../_metronic/layout/components/toolbar/Toolbar2'
import {QueryRequestProvider} from './components/property-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './components/property-list/core/QueryResponseProvider'
import {ListViewProvider} from './components/property-list/core/ListViewProvider'
import {KTCard} from '../../../../_metronic/helpers'
import {PropertiesListHeader} from './components/property-list/components/header/PropertiesListHeader'
import {PropertiesListWrapper} from './components/property-list/PropertiesList'
import {PropertiesWrapper} from './pages/dashboard/PropertiesWrapper'

const PropertiesPage: FC = () => {
  const intl = useIntl()
  return (
    <>
      <Toolbar2
        icon={true}
        router='/addproperties'
        subtitle={intl.formatMessage({id: 'PROPERTIES.TITLE'})}
      />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'PROPERTIES.TITLE'})}</PageTitle>
      <AnimaFadeinTop>
        <div className='card mb-3'>
          <div className='card-header justify-content-start d-flex align-items-center'>
            <ul className='nav'>
              <li className='nav-item me-5'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary active'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_1'
                >
                  {intl.formatMessage({id: 'MENU.DASHBOARD'})}
                </a>
              </li>
              <li className='nav-item me-5'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary '
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_2'
                >
                  {intl.formatMessage({id: 'PROPERTIES.TITLE_LIST'})}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <QueryRequestProvider>
          <QueryResponseProvider>
            <ListViewProvider>
              <KTCard className='pb-5'>
                <PropertiesListHeader />
              </KTCard>
              <div className='tab-content' id='myTabContent'>
                <div className='tab-pane fade active show' id='kt_tab_pane_1' role='tabpanel'>
                  <PropertiesWrapper />
                </div>
                <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'>
                  <PropertiesListWrapper />
                </div>
              </div>
            </ListViewProvider>
          </QueryResponseProvider>
        </QueryRequestProvider>
      </AnimaFadeinTop>
    </>
  )
}

export {PropertiesPage}
